import * as Data from './data';
import { TokenRepository } from '../TokenRepository';

const HandleMFA =() => {
    var tokenRepository = new TokenRepository();
    var heldToken = tokenRepository.getHoldToken();    
    Data.retrieveToken(heldToken.holdTokenKey).then((token) => {
        tokenRepository.saveToken(token);
        tokenRepository.clearHoldToken();
        window.location.reload();
    });
   
    return (
        <div>Validating Duo Web call</div>
    );
}

export default HandleMFA;